import { UserProfileGetResponse } from '@core/layouts/types/user-profile.type';
import { UserPermissionResponse } from '@core/types/permission.type';
import {
  ApiResponse,
  PermissionAPIResponse,
  ThirdPartyFleetPermissionResponse,
  ThirdPartyGroupPermissionResponse,
} from '@entities/types';
import { InjectableApi } from '@shared/decorators';
import { ApiService } from '../../shared/services/api.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@InjectableApi({
  providedIn: 'root',
  baseSegment: '',
})
export class PermissionService extends ApiService {
  fetchUserPermissions(): Observable<UserPermissionResponse> {
    this.baseUrl = environment.drm_base_url;
    return this.get(`/user/permission`, false, {}, 'v1');
  }

  getUserProfile(): Observable<UserProfileGetResponse> {
    this.version = 'v1';
    return this.get(`/user/profile`);
  }

  getSublinkGroups<T extends object>(): Observable<T> {
    return this.get(`/group/sublink-permission`);
  }

  getPermissionOptions() {
    return this.get<PermissionAPIResponse>('/group/fixed-permission-options');
  }

  getThirdPartyPermissions(id: string) {
    return this.get<ApiResponse<ThirdPartyGroupPermissionResponse>>(
      `/group/third-party-group/${id}`,
    );
  }

  getThirdParyFleetPermission(clientID: string) {
    return this.get<ApiResponse<ThirdPartyFleetPermissionResponse>>(
      `/client/lease-company/third-party-fleet-permission?clientId=${clientID}`,
    );
  }
}
